import Controller from "./progressIndicator.controller";
import template from "./progressIndicator.html";

const progressIndicator = {
  template,
  controller: Controller,
  bindings: {
    exact: "<",
    max: "<",
    tooltip: "@",
  },
};

export default progressIndicator;



// WEBPACK FOOTER //
// ./src/components/progressIndicator/progressIndicator.component.js